export const STORAGE = {
  ORDER_MOBILE: 'flowMobile',
  ORDER_CACHE_KEY: 'orderCache',
  SMSCODE_SEND_TIME: 'SMSCodeSendTime',
  SMSCODE_ORDER_ID: 'SMSCodeOrderId',
  RECEIVE_GOODS_SUCCESS: 'ReceiveGoodsSucess',
};

// 翼支付订单id Storage Key
export const generateYZFOrderIdKey = (mobile) => `OrderIdOf302_${mobile}`;
